<template>
  <div class="preview" v-if="previewData">
    <div class="preview__label">
      Text preview
    </div>
    <div class="preview__text">When <red-text class="red-text">{{previewData.tickerName}} ({{previewData.tickerSymbol}})</red-text>
      <red-text class="red-text red-text_lowercase">{{previewData.valueType | formatValueType}} {{previewData.changeType}}</red-text>
      by&nbsp;<red-text>{{previewData.changeDelta}}</red-text> from
      <red-text class="red-text">{{previewData.currentValue | formatMoney(currencyCode)}}</red-text>
      to&nbsp;<red-text class="red-text">{{previewData.targetValue | formatMoney(currencyCode)}}</red-text>,<br class="text-break"/> send me&nbsp;a&nbsp;
      <red-text class="red-text" v-html="channelsList"></red-text>.
    </div>
  </div>
</template>

<script>
import { valueTypes } from 'src/models/AlertsValueTypes';
import { formatMoney } from 'src/utils/helpers';

export default {
  props: {
    formData: Object,
    previewData: Object,
    currencyCode: String,
  },
  filters: {
    formatMoney,
    formatValueType(valueType) {
      const foundValueType = valueTypes.find(p => p.name === valueType);
      return foundValueType && foundValueType.value;
    },
  },
  computed: {
    channelsList() {
      let frequency = '';
      let notificationText = 'notification';
      if (this.formData.frequency === 'one_time_event') {
        frequency = 'one time';
      }
      if (this.formData.frequency === 'persistent') {
        frequency = 'persistent';
        notificationText = 'notifications';
      }
      const channels = ['platform'];
      if (this.formData.withSMS) {
        channels.push('sms');
      }
      if (this.formData.withPush) {
        channels.push('push');
      }
      if (this.formData.withWebhook) {
        channels.push('webhook');
      }
      if (this.formData.withEmail) {
        channels.push('email');
      }
      let channelsText;
      if (channels.length > 1) {
        const leftPartArray = channels.slice(0, channels.length - 1);
        const rightPart = channels[channels.length - 1];
        channelsText = `${leftPartArray.join(', ')} <span class="black-text"> and </span> ${rightPart}`;
      } else {
        channelsText = channels[0];
      }
      return `${frequency} ${channelsText} ${notificationText}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.preview {
  @include customBorder(4px, 1px, 0);
  border-radius: 5px;
  width: 100%;
  min-height: 143px;
  margin-top: 4px;
  padding: 39px 29px;
  &__label {
    @include label;
  }
  &__text {
    line-height: 22px;
    margin-top: 13px;
    font-size: 14px;
  }
}
.red-text {
  display: inline-block;
  &_lowercase {
    text-transform: lowercase;
  }
}
.black-text {
  color: $black-color1;
}
@media only screen and (max-width : 992px) {
  .text-break {
    display: none;
  }
  .red-text {
    @include incrSelectorWeight(1) {
      display: inline;
    }
  }
}
@media only screen and (max-width : 753px) {
  .preview {
    margin: 16px auto 10px;
    width: calc(100% - 30px);
    padding: 39px 20px;
  }
}
@media only screen and (max-width : 582px) {
  .body-block_stage2 .preview {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/alertCreation/TextPreview.vue